/** Matches `AiProviderKind.AZURE_OPENAI` (`apps/backend/src/enums/ai/ai-provider-kind.enum.ts`): the only
 * provider kind whose every URL carries an `?api-version=` query parameter. */
const AZURE_OPENAI_KIND = 'azure_openai';

/** The minimal shape this constraint reads: only `kind` drives whether the API version is mandatory. */
type ApiVersionRequirementShape = {
	readonly kind: string;
};

/**
 * Generic over the minimal shape it reads, not over `AiProviderFormData` itself, so the FormData never
 * has to import its own constraint back (`guides/forms.md` §1.1). Every other provider kind leaves the
 * field empty: Azure OpenAI is the only family whose outgoing client appends `?api-version=` to every
 * request.
 */
function isApiVersionProvided<T extends ApiVersionRequirementShape>(value: string, formData: T): boolean {
	if (formData.kind !== AZURE_OPENAI_KIND) {
		return true;
	}

	return value !== '';
}

export default isApiVersionProvided;
